import React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Icon, Tooltip } from "components/common";
const StyledIcon = styled(Icon)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xxs};
  `
);
const CAPABILITY_TEXTS = {
  view: "restricted_access.view"
};
const RestrictedAccessTooltip = ({ entityName, capabilityName }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(Tooltip, { label: t(CAPABILITY_TEXTS[capabilityName], { entityName }) }, /* @__PURE__ */ React.createElement(StyledIcon, { size: "xs", name: "lock" }));
};
export default RestrictedAccessTooltip;
